// extracted by mini-css-extract-plugin
export var label = "_eq-2";
export var slideContainer = "_eq-0";
export var slider = "_eq-1";